import { SlideGroupName } from 'generated/graphql';
import _ from 'lodash';



interface IPitchDeckTemplateData {
  id: string;
  slideGroup: {
    name: SlideGroupName;
    displayName: string;
  };
  thumbnailKey: string;
  slide?: {
    id: string;
    key: string;
    fileName: string;
  };
  title: string;
}



export const displayingThumbnails: { [key in SlideGroupName]: string[] } = {
  bySlideType: [
    'Ridge_Mission_3.JPG',
    'Ridge_Problem_3.JPG',
    'Ridge_Solution_3.JPG',
    'Ridge_Front_Cover_1.JPG',
    'Ridge_How_It_Works_1.JPG',
    'Ridge_Revenue_Model_4.JPG',
    'Ridge_Differentiation_2.JPG',
    'Ridge_Traction_1.JPG',
    'Ridge_Market_3.JPG',
    'Ridge_I_P_1.JPG',
    'Ridge_Team_8.JPG',
    'Ridge_Growth_Plan_5.JPG',
    'Ridge_Funding_Need_3.JPG',
    'Ridge_Financial_Projections_8.JPG',
    'Ridge_Case_Study_1.JPG',
    'Ridge_End_Cover_1.JPG'
  ],
  byPitchExample: [
    'Ridge_Dumm_1.JPG',
    'Ridge_Totler_1.JPG',
    'Ridge_Temptt_1.JPG',
    'Ridge_Ugly_Soup_1.JPG',
    'Ridge_Unsightly_1.JPG'
  ],
  otherResources: [
    'Ridge_Icons_1.JPG',
    'Ridge_Category_1.JPG',
    'Ridge_Other_1.JPG'
  ]
};



const titles = [
  'Mission',
  'Problem',
  'Solution',
  'Front Cover',
  'How It Works',
  'Revenue Model',
  'Differentiation',
  'Traction',
  'Market',
  'Intellectual Property',
  'Team',
  'Growth Plan',
  'Funding Need',
  'Financial Projections',
  'Case Study',
  'End Cover',

  'Dumm Glasses',
  'Totler',
  'Unsightly',
  'Temptt',
  'Ugly Soup',

  'Icon Library',
  'Categories Slides',
  'Other Slides'
];

const title2RankingOverride = _.mapValues(_.keyBy(titles, t => t), v => _.indexOf(titles, v));



function __getOrderFromFileName(fileName: string) {
  const name = fileName.split('.')[0];
  let nonNumericStartingIndex = name.length - 1;

  while (!isNaN(parseInt(name.charAt(nonNumericStartingIndex)))) {
    nonNumericStartingIndex -= 1;
  }

  return parseInt(name.slice(nonNumericStartingIndex + 1));
}




export function getRankingFromTitle(title: string): number {
  return title2RankingOverride[title] ?? titles.length;
}



export function getRankingFromSlides (item: IPitchDeckTemplateData): number {
  if (!item.slide) {
    return getRankingFromTitle(item.title);
  }
  return __getOrderFromFileName(item.slide.fileName);
}

